export const APP_URLS = {
  home: '/',
  registration: '/registration',
  login: '/login',
  help: 'https://help.betzone.co.uk',
  virtualGames: {
    home: '/virtual-games',
  },
  myAccount: {
    home: '/my-account',
    profile: '/my-account/profile',
    activity: '/my-account/activity',
    settings: '/my-account/settings',
    gamblingControls: '/my-account/gambling-controls',
    bonusHistory: '/bonus-history',
  },
  gameDetails: '/game-details/:name/*',
  promotionsRoot: '/promotions',
  promotions: '/promotions/:id?/:subId?',
  contentPage: '/pages/:slug',
  gam: '/gam/:slug',
  gameLobby: {
    main: '/game-lobby',
    dynamicPage: '/game-lobby/:category/:subcategory?',
  },
  privacyPolicy: '/pages/privacy-policy',
  cookiePolicy: '/pages/cookie-policy',
  terms: '#terms',
};
